import create from 'zustand';
import { persist } from 'zustand/middleware';
import { salesNotificationService } from '../services/salesNotificationService';
import authService from '../services/authService';
import { salesRoles } from '../assets/helpers/roles';

const ROLES_WITH_INBOX = [
  salesRoles.SALES_DEVELOPER,
  salesRoles.SALES_ADMIN,
  salesRoles.SALES_SUPERVISOR,
  salesRoles.SALES_ADMIN_AUX,
  salesRoles.SALES_COUNTER,
  salesRoles.SALES_FARMER,
  salesRoles.SALES_HUNTER,
  salesRoles.SALES_KEY_ACCOUNTS,
];

export const useInboxCountStore = create(
  persist(
    (set) => ({
      inboxCount: 0,
      fetchInboxCount: async () => {
        if (!ROLES_WITH_INBOX.includes(authService?.getUserType())) return;
        try {
          const response = await salesNotificationService.getSalesNotificationCount();
          if (response?.status === 200 && response?.data != null) {
            const count =
              typeof response.data === 'number'
                ? response.data
                : response.data?.count ?? 0;
            set({ inboxCount: count });
          }
        } catch {}
      },
    }),
    {
      name: 'inbox-count-storage',
      partialize: (state) => ({ inboxCount: state.inboxCount }),
    }
  )
);
